export default __webpack_public_path__ + "static/media/TotalDePropostas.21f73c38.svg";